import { mapTranslator } from './translators/map';
import {
  createDocumentDomainHook,
  createDomainUpdateHook,
} from './domainHookFactory';
import type { MapSettings } from './types';

export const useMapSettings = createDocumentDomainHook<MapSettings>(
  'map',
  mapTranslator,
);

export const useUpdateMapSettings =
  createDomainUpdateHook<MapSettings>(useMapSettings);
